import shoppingCartPage from './pages/shoppingCart/shoppingCart.js';
import paymentDetailsPage from './pages/paymentDetails/paymentDetails.js';
import companyDetailsPage from './pages/companyDetails/companyDetails.js';
import confirmOrderPage from './pages/confirmOrder/confirmOrder.js';
import thankYouPage from './pages/thankYou/thankYou.js';
import invoicePage from './pages/invoice/invoice.js';
import paymentGatewayIframePage from './pages/paymentGatewayIframe/paymentGatewayIframe.js';
import paymentGatewayReturnPage from './pages/paymentGatewayReturn/paymentGatewayReturn.js';

export default [{
	path: '',
	name: 'shopping-cart',
	component: shoppingCartPage,
	meta: {
		name: 'Shopping Cart Page',
		tracking: 'Billing Info',
		number: 0,
		forms: ['customer', 'payment']
	}
}, {
	path: 'payment-details',
	name: 'payment-details',
	component: paymentDetailsPage,
	meta: {
		name: 'Payment Details',
		tracking: 'Payment Info',
		number: 1,
		forms: []
	}
}, {
	path: 'company-details',
	name: 'company-details',
	component: companyDetailsPage,
	meta: {
		name: 'Company Details',
		tracking: 'Company Info',
		number: 1,
		forms: [] // @todo add form to debugBar form filler
	}
}, {
	path: 'confirm-order',
	name: 'confirm-order',
	component: confirmOrderPage,
	meta: {
		name: 'Confirm Order Page',
		tracking: 'Review',
		number: 3,
		forms: []
	}
}, {
	path: 'thank-you',
	name: 'thank-you',
	component: thankYouPage,
	meta: {
		name: 'Thank You Page',
		tracking: 'Purchase',
		number: 4,
		forms: []
	}
}, {
	path: 'invoice',
	name: 'invoice',
	component: invoicePage,
	meta: {
		name: 'Invoice Page',
		tracking: 'Invoice Page',
		number: 5,
		forms: []
	}
}, {
	path: 'payment/gateway-iframe',
	name: 'payment-gateway-iframe',
	component: paymentGatewayIframePage,
	meta: {
		name: 'Payment Gateway Iframe',
		isBlankPage: true
	}
}, {
	path: 'payment/gateway-return',
	name: 'payment-gateway-return',
	component: paymentGatewayReturnPage,
	meta: {
		name: 'Payment Gateway Return',
		isBlankPage: true
	}
}];
